// extracted by mini-css-extract-plugin
export var attachButton = "_ch-8";
export var sendButton = "_ch-2";
export var sendDisabled = "_ch-4";
export var sendEnabled = "_ch-3";
export var sendIcon = "_ch-6";
export var sendIconDisabled = "_ch-7";
export var sendStreaming = "_ch-5";
export var textarea = "_ch-1";
export var wrapper = "_ch-0";